import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import DueDiligence from 'screens/Panel/screens/Network/components/DueDiligence/DueDiligence';
import { DueDiligence as DueDiligenceType } from 'utils/api/types';
import reloadNetwork from 'screens/Panel/screens/Network/store/show/useCases/reloadNetwork';

export default connect(
  (state: RootState) => {
    return {
      networkId: state.networkShow.network?.company.id || '',
      dueDiligence: state.networkShow.network?.company.dueDiligence as DueDiligenceType,
      user: state.auth.user,
    };
  },
  { reloadNetwork },
)(DueDiligence);
